<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
    }}</b-alert>
    <b-container fluid>
      <b-breadcrumb v-if="($store.state.user_obj.user_id != '1094')" class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-button v-if="
        ($store.state.user_obj.user_id != '1094')
        &&
        ($store.state.user_obj.account_type != 'client_user')
        &&
        checkPermission(
          $store.state.user_obj,
          'Delivery Management',
          'Delivery Status/Detail/',
          'Edit Order Detail',
          true
        )
      " class="btn-action mb-3" size="sm" variant="info"
        :to="{ name: 'tracking_edit', params: { id: tracking.id } }">Edit</b-button>

      <b-button v-if="$store.state.user_obj.account_type == 'young_living'" class="btn-action mb-3" size="sm"
        variant="info" :to="{
          name: 'change_request_edit',
          params: { tracking_id: tracking.id },
        }">Raise Delivery Case</b-button>

      <b-button v-if="$store.state.user_obj.account_type == 'young_living'" class="btn-action mb-3" size="sm"
        variant="info" :to="{
          name: 'cs_issue_edit',
          params: { tracking_id: tracking.id },
        }">Raise CS Case</b-button>

      <b-card class="mb-1">
        <b-row>
          <b-col class="col-2">
            <strong>Client name</strong>
          </b-col>
          <b-col>{{ tracking.client_name }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Order #</strong>
          </b-col>
          <b-col>{{ tracking.order_number }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Courier name</strong>
          </b-col>
          <b-col>{{ tracking.courier_short_name }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Tracking #</strong>
          </b-col>
          <b-col>{{ tracking.tracking_number }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Status</strong>
          </b-col>
          <b-col>{{ tracking.status }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Process Date</strong>
          </b-col>
          <b-col>
            <span v-if="!tracking.reschedule_delivery_date">{{
              displayDate(tracking.schedule_date)
            }}</span>
            <span v-if="tracking.reschedule_delivery_date">{{ tracking.reschedule_type }}
              {{ displayDate(tracking.reschedule_delivery_date) }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Scheduled Delivery Date</strong>
          </b-col>
          <b-col>
            <span v-if="!tracking.scheduled_delivery_date">-</span>
            <span v-if="tracking.scheduled_delivery_date">{{
              tracking.scheduled_delivery_date
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Attention</strong>
          </b-col>
          <b-col>
            <span v-if="!tracking.attention_driver">{{
              tracking.attention
            }}</span>
            <span v-if="tracking.attention_driver">{{
              tracking.attention_driver
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Phone</strong>
          </b-col>
          <b-col>
            <span v-if="!tracking.phone_driver">{{ tracking.phone }}</span>
            <span v-if="tracking.phone_driver">{{
              tracking.phone_driver
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Address</strong>
          </b-col>
          <b-col>
            <span v-if="!tracking.address_driver">{{ tracking.address }}</span>
            <span v-if="tracking.address_driver">{{
              tracking.address_driver
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong># of ctns</strong>
          </b-col>
          <b-col>
            {{ tracking.ctns || "-" }}
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Route</strong>
          </b-col>
          <b-col>
            {{ tracking.route || "-" }}
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Remark</strong>
          </b-col>
          <b-col>{{ tracking.remark || "-" }}</b-col>
        </b-row>

        <b-row v-if="tracking.extra_fee">
          <b-col class="col-2">
            <strong>Extra Fee</strong>
          </b-col>
          <b-col>${{ tracking.extra_fee }} ({{ tracking.extra_fee_comment }})</b-col>
        </b-row>

        <b-row v-if="!(($store.state.user_obj.account_type == 'client_user')
          && tracking.pod_type == 'photo'
        ) && $store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>POD</strong>
          </b-col>
          <b-col>
            <!-- <a
              v-if="tracking.pod_image"
              :href="tracking.pod_image"
              target="_blank"
            >{{tracking.pod_type}}</a> -->
            <b-button class="btn-action txt_camelcase" size="sm" variant="info" v-if="tracking.pod_image"
              @click="showPod(tracking)">{{ tracking.pod_type }}</b-button>

            <b-button class="btn-action" size="sm" variant="danger" v-if="
              tracking.pod_image &&
              $store.state.user_obj.account_type != 'young_living' &&
              $store.state.user_obj.account_type != 'client_user'
            " @click="showModal_removePod(tracking)">Remove POD</b-button>
            <span v-if="!tracking.pod_image">-</span>
          </b-col>
        </b-row>

        <b-row v-if="epodExists">
          <b-col class="col-2">
            <strong>ePOD</strong>
          </b-col>
          <b-col>
            <b-button class="btn-action" size="sm" variant="info" @click="downloadEpod">
              Download ePOD
            </b-button>
          </b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>Carried by</strong>
          </b-col>
          <b-col>
            <!-- <span v-if="$store.state.user_obj.account_type != 'young_living'">
              {{ tracking.carried_by }}
            </span>
            <span v-if="$store.state.user_obj.account_type == 'young_living'">
              Driver
            </span> -->

            <span v-if="tracking.carried_by && tracking.carried_by != ''">
              <span v-if="$store.state.user_obj.account_type != 'client_user'">
                {{ tracking.carried_by }}
              </span>
              <span v-if="$store.state.user_obj.account_type == 'client_user'">
                -
              </span>
            </span>
            <span v-if="!(tracking.carried_by && tracking.carried_by != '')">
              -
            </span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Last Updated</strong>
          </b-col>
          <b-col>{{ tracking.updated_at }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>Payment Type</strong>
          </b-col>
          <b-col>{{ tracking.payment_type || "-" }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>Payment Status</strong>
          </b-col>
          <b-col>{{ tracking.payment_status || "-" }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>Payment Amount</strong>
          </b-col>
          <b-col>{{ tracking.payment_amount || "-" }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>Payment Paid</strong>
          </b-col>
          <b-col>{{ tracking.payment_paid || "-" }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>Payment Ref</strong>
          </b-col>
          <b-col>{{ tracking.payment_ref || "-" }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>Packing Sector</strong>
          </b-col>
          <b-col>{{ tracking.packing_sector || "-" }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>Packing Remark</strong>
          </b-col>
          <b-col>{{ tracking.packing_remark || "-" }}</b-col>
        </b-row>
      </b-card>

      <h4 class="mt-3">Status History</h4>

      <b-card>
        <b-table responsive small outlined striped hover :items="history_items" :fields="history_fields">
          <template v-slot:cell(status)="data">
            {{ data.item.status }}
            <!-- <span v-if="data.item.status_reason"
              >- {{ data.item.status_reason }}</span
            > -->
            <span v-if="data.item.other_reason">
              <br />
              [{{ data.item.other_reason }}]
            </span>

            <span v-if="data.item.reschedule_delivery_date">
              <br />
              [{{ data.item.reschedule_delivery_date }}]
            </span>
          </template>

          <template v-slot:cell(updated_by)="data">
            <span v-if="$store.state.user_obj.account_type != 'client_user'">
              {{ data.item.updated_by_name }}
            </span>
            <span v-if="$store.state.user_obj.account_type == 'client_user'">
              -
            </span>
          </template>

          <template v-slot:cell(pod_image)="data">
            <a v-if="(!(($store.state.user_obj.account_type == 'client_user')
              && tracking.pod_type == 'photo'
            ) && $store.state.user_obj.account_type != 'client_user_masked') && data.item.pod_image"
              :href="data.item.pod_image" target="_blank">{{ data.item.pod_type }}</a>
            <span v-if="((($store.state.user_obj.account_type == 'client_user')
              && tracking.pod_type == 'photo'
            ) && $store.state.user_obj.account_type != 'client_user_masked') || !data.item.pod_image">-</span>
          </template>

          <template v-slot:cell(action)="data">
            <!-- <b-button class="btn-action" size="sm" variant="danger"
              v-if="$store.state.user_obj.account_type != 'young_living'"
              @click.stop="showModal_cancelTracking(data.item)">Delete</b-button> -->
            <b-button class="btn-action" size="sm" variant="danger"
              v-if="$store.state.user_obj.account_type == 'client_admin' || $store.state.user_obj.account_type == 'admin'"
              @click.stop="showModal_EditStatusDate(data.item)">Edit Date</b-button>
          </template>
        </b-table>
      </b-card>

      <h4 class="mt-3">Orders</h4>


      <b-card v-for="(order_master, i) in order_masters" :key="i" class="mt-1">
        <!-- <h5>Order Info</h5> -->
        <!-- <b-row>
                        <b-col class="col-2">
                            <strong>Client Name</strong>
                        </b-col>
                        <b-col v-if="order_master.tracking_obj">{{
                            order_master.tracking_obj.client_name
                        }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Channel</strong>
                        </b-col>
                        <b-col>{{ order_master.channel }}</b-col>
                    </b-row> -->

        <b-row>
          <b-col class="col-1">
            <strong>Order #</strong>
          </b-col>
          <b-col>{{ order_master.order_number }}</b-col>
        </b-row>

        <!-- <b-row
                        v-if="
                            order_master.related_orders &&
                                order_master.related_orders.length > 0
                        "
                    >
                        <b-col class="col-2">
                            <strong>Related Orders</strong>
                        </b-col>
                        <b-col>
                            <router-link
                                target="_blank"
                                :key="ri"
                                v-for="(related_order,
                                ri) in order_master.related_orders"
                                :to="{
                                    name: 'order_master_detail',
                                    params: {
                                        order_master_id: related_order.id
                                    }
                                }"
                            >
                                {{ related_order.order_number }}
                            </router-link>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Upload Date</strong>
                        </b-col>
                        <b-col>
                            {{ displayDate(order_master.created_at) }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Order Date</strong>
                        </b-col>
                        <b-col>
                            {{ displayDate(order_master.order_date) }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Scheduled Delivery</strong>
                        </b-col>
                        <b-col>
                            {{
                                displayDate(
                                    order_master.scheduled_delivery_date
                                )
                            }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Customer Name</strong>
                        </b-col>
                        <b-col>{{ order_master.customer_name }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Customer Phone</strong>
                        </b-col>
                        <b-col>{{ order_master.customer_phone || "-" }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Customer Address</strong>
                        </b-col>
                        <b-col>{{ order_master.customer_address }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Customer Email</strong>
                        </b-col>
                        <b-col>{{ order_master.customer_email || "-" }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Last Updated</strong>
                        </b-col>
                        <b-col>{{ order_master.updated_at }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Order Status</strong>
                        </b-col>
                        <b-col>
                            <div>
                                <span class="txt_camelcase">{{
                                    order_master.order_import_status
                                }}</span>

                                <span
                                    v-if="
                                        order_master.order_import_status ==
                                            'cancel'
                                    "
                                    class="dot_red"
                                ></span>
                                <span
                                    v-if="
                                        order_master.order_import_status ==
                                            'hold'
                                    "
                                    class="dot_red"
                                ></span>
                                <span
                                    v-if="
                                        order_master.order_import_status ==
                                            'pending'
                                    "
                                    class="dot_yellow"
                                ></span>
                                <span
                                    v-if="
                                        order_master.order_import_status ==
                                            'received'
                                    "
                                    class="dot_green"
                                ></span>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Stock Status</strong>
                        </b-col>
                        <b-col>
                            <div>
                                <span class="txt_camelcase">{{
                                    order_master.stock_status
                                }}</span>

                                <span
                                    v-if="order_master.stock_status == '-'"
                                    class="dot_white"
                                ></span>
                                <span
                                    v-if="
                                        order_master.stock_status == 'pending'
                                    "
                                    class="dot_red"
                                ></span>
                                <span
                                    v-if="
                                        order_master.stock_status == 'available'
                                    "
                                    class="dot_yellow"
                                ></span>
                                <span
                                    v-if="
                                        order_master.stock_status == 'committed'
                                    "
                                    class="dot_green"
                                ></span>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Fulfilment Status</strong>
                        </b-col>
                        <b-col>
                            <div>
                                <span class="txt_camelcase">{{
                                    order_master.fulfilment_status
                                }}</span>

                                <span
                                    v-if="order_master.fulfilment_status == '-'"
                                    class="dot_white"
                                ></span>
                                <span
                                    v-if="
                                        order_master.fulfilment_status ==
                                            'pending'
                                    "
                                    class="dot_yellow"
                                ></span>
                                <span
                                    v-if="
                                        order_master.fulfilment_status ==
                                            'completed'
                                    "
                                    class="dot_green"
                                ></span>
                                <span
                                    v-if="
                                        order_master.fulfilment_status ==
                                            'fulfiled'
                                    "
                                    class="dot_green"
                                ></span>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Remarks</strong>
                        </b-col>
                        <b-col>{{ order_master.remarks }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col class="col-2">
                            <strong>Delivery Remarks</strong>
                        </b-col>
                        <b-col v-if="order_master.tracking_obj">{{
                            order_master.tracking_obj.remark
                        }}</b-col>
                    </b-row> -->

        <!-- <h5 class="mt-3">
                        Products
                    </h5> -->

        <!-- <hr /> -->
        <b-table class="mt-2" responsive small striped hover :items="order_master.products" :fields="product_fields">
          <template v-slot:cell(cover_image)="data">
            <img :src="data.item.cover_image" width="50" />
          </template>
          <template v-slot:cell(stock_status)="data">
            <span v-if="data.item.stock_status != 'back_order'">{{
              data.item.stock_status
              }}</span>

            <router-link target="_blank" v-if="data.item.stock_status == 'back_order'" :to="{
              name: 'order_master_detail',
              params: { order_master_id: data.item.bo_id },
            }">
              {{ data.item.stock_status }} ({{ data.item.bo_number }})
            </router-link>
          </template>
        </b-table>
        <hr />
        <h5>Delivery Case</h5>
        <b-table responsive small outlined striped hover :items="order_master.cr_items" :fields="cr_fields">
          <template v-slot:cell(status)="data">{{
            data.item.status
            }}</template>

          <template v-slot:cell(field_name)="data">
            <span v-if="data.item.field_name != 'courier_short_name'">{{
              data.item.field_name
              }}</span>

            <span v-if="data.item.field_name == 'courier_short_name'">
              courier
            </span>
          </template>

          <template v-slot:cell(changes)="data">
            <div style="
                  max-width: 250px;
                  white-space: pre-line;
                  word-break: break-word;
                ">{{ data.item.to_val }}<div v-if="data.item.other_reason"></div>
            </div>
          </template>

          <template v-slot:cell(remark)="data"> </template>

          <template v-slot:cell(updated_at)="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.updated_at }}
            </div>
          </template>
        </b-table>
      </b-card>


      <!-- <h4 class="mt-3">
        Products
      </h4>

      <b-card>
        <b-table
          responsive
          small
          outlined
          striped
          hover
          :items="order_master_products"
          :fields="product_fields"
        >
          <template v-slot:cell(cover_image)="data">
            <img :src="data.item.cover_image" width="50" />
          </template>
          <template v-slot:cell(action)="data">
            <b-button
              class="btn-action"
              size="sm"
              variant="danger"
              v-if="$store.state.user_obj.account_type != 'young_living'"
              @click.stop="showModal_cancelTracking(data.item)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </b-card> -->

      <!-- <h4 class="mt-3">Delivery Case</h4>
      <b-card>
        <b-table
          responsive
          small
          outlined
          striped
          hover
          :items="cr_items"
          :fields="cr_fields"
        >
          <template v-slot:cell(status)="data">{{
            data.item.status
          }}</template>

          <template v-slot:cell(changes)="data">
            <div
              style="max-width: 250px; white-space: pre-line; word-break: break-word;"
            >{{ data.item.from_val }} -> {{ data.item.to_val }}
              <div v-if="data.item.other_reason">
                [{{ data.item.other_reason }}]
              </div>
              <div
                v-if="
                  data.item.reschedule_date &&
                    data.item.reschedule_date != '0000-00-00 00:00:00'
                "
              >
                [{{ data.item.reschedule_date }}]
              </div>
            </div>
          </template>

          <template v-slot:cell(remark)="data">
            <div
              style="max-width: 200px; white-space: pre-line; word-break: break-word;"
            >
              {{ data.item.remark }}
            </div>
          </template>

          <template v-slot:cell(updated_at)="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.updated_at }}
            </div>
          </template>

          <template v-slot:cell(action)="data">
            <b-button
              v-if="
                ($store.state.user_obj.account_type == 'admin' ||
                  $store.state.user_obj.account_type == 'cs') &&
                  data.item.status == 'pending'
              "
              class="btn-action"
              size="sm"
              variant="success"
              @click.stop="executeCR(data.item)"
              >Execute</b-button
            >

            <b-button
              v-if="data.item.status == 'pending'"
              class="btn-action"
              size="sm"
              variant="danger"
              @click.stop="cancelCR(data.item)"
              >Cancel</b-button
            >
          </template>
        </b-table>
      </b-card> -->

      <!-- <h4 class="mt-3">CS Case</h4>

      <cs-issue-card
        :key="item_index"
        v-for="(item, item_index) in items"
        :item="item"
        :mode="($store.state.user_obj.account_type == 'admin' ||
                  $store.state.user_obj.account_type == 'cs')?'edit':'view'"
      ></cs-issue-card> -->

      <b-modal ref="modal_removePod" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>
              <strong>Are you sure to remove POD?</strong>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_removePod">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="removePod()">Confirm</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_cancelTracking" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>
              <strong>Are you sure to delete status?</strong>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="col-2">
              <strong>Date:</strong>
            </b-col>
            <b-col>{{ updating_item.updated_at }}</b-col>
          </b-row>

          <b-row>
            <b-col class="col-2">
              <strong>Status:</strong>
            </b-col>
            <b-col>{{ updating_item.status }}</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_cancelTracking">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="deleteTrackingStatus()">Confirm</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_editStatusDate" centered hide-footer title="Edit Status Date">
        <div class="d-block">
          <b-form-group label="Status Date">
            <!-- <b-form-datepicker v-model="editStatusDate" :value="editStatusDate" required></b-form-datepicker> -->
            <b-form-input type="text" required placeholder v-model="editStatusDate"></b-form-input>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-btn variant="outline-danger" class="mt-2" @click="hideModal_editStatusDate">Cancel</b-btn>
          <b-btn variant="outline-success" class="mt-2" @click="saveEditStatusDate">Save</b-btn>
        </div>
      </b-modal>

    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_id",
    label: "Order#",
  },
  {
    key: "barcode",
    label: "Barcode",
  },
  {
    key: "attention",
    label: "Attention",
  },
  {
    key: "phone",
    label: "Phone",
  },
  {
    key: "status",
    label: "Status",
  },
  {
    key: "schedule_date",
    label: "Scheduled Date",
  },
  {
    key: "pod_image",
    label: "POD Record",
  },
  {
    key: "carried_by",
    label: "Carried by",
  },
  {
    key: "updated_at",
    label: "Last Updated",
  },
];

const product_fields = [
  {
    key: "product_sku",
    label: "Product SKU",
  },
  {
    key: "product_channel_sku",
    label: "Other SKU",
  },
  {
    key: "product_description",
    label: "Product Description",
  },
  {
    key: "product_qty",
    label: "Quantity",
  },
  {
    key: "committed_qty",
    label: "Committed",
  },
  {
    key: "stock_status",
    label: "Stock Status",
  },
];

const history_fields = [
  {
    key: "updated_at",
    label: "Updated at",
  },
  {
    key: "status",
    label: "Status",
  },
  {
    key: "pod_image",
    label: "POD",
  },
  {
    key: "updated_by",
    label: "Updated by",
  },
];

const masked_history_fields = [
  {
    key: "updated_at",
    label: "Updated at",
  },
  {
    key: "status",
    label: "Status",
  },
];

import CsIssue_Card from "../components/CsIssue_Card.vue";
import global_function from "../mixins/global_function";
export default {
  name: "TrackingDetail",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  mixins: [global_function],
  components: {
    barcode: VueBarcode,
    "cs-issue-card": CsIssue_Card,
  },
  data() {
    return {
      editStatusDate: null,
      editing_status_item: null,
      epodExists: false,
      updating_item: false,
      breadcrumb_items: [
        {
          text: "Trackings",
          to: { name: "trackings" },
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      cr_items: [],
      cr_fields: [
        {
          key: "field_name",
          label: "Field Name",
        },
        {
          key: "changes",
          label: "Changes",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "created_by",
          label: "Requested By",
        },
        {
          key: "updated_by",
          label: "Executed By",
        },
      ],

      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "pod_image",
          label: "POD",
        },
        {
          key: "updated_by",
          label: "Updated by",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      loader: false,
      items: [{ id: false }],
      tracking: { id: false },
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null,
      },
      status_options: [
        {
          value: null,
          text: "All Status",
        },
        {
          value: "Pending",
          text: "Pending",
        },
        {
          value: "In-Transit",
          text: "In-Transit",
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse",
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery",
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse",
        },
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before",
        },
        {
          value: "on",
          text: "on",
        },
        {
          value: "after",
          text: "after",
        },
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      order_master_products: [],
      product_fields: [
        {
          key: "product_sku",
          label: "Product SKU",
        },
        {
          key: "product_channel_sku",
          label: "Other SKU",
        },
        {
          key: "product_description",
          label: "Product Description",
        },
        {
          key: "product_qty",
          label: "Quantity",
        },
        {
          key: "committed_qty",
          label: "Committed",
        },
        {
          key: "stock_status",
          label: "Stock Status",
        },
      ],
      order_masters: [],
    };
  },
  async created() {
    await this.getTracking();
    await this.checkEpodExists(); // Check if ePOD exists
    await this.getOrderMasterProduct();
    this.initialized = true;

    if (this.$store.state.user_obj.account_type == "client_user_masked") {
      this.history_fields = masked_history_fields;
      this.$root.$emit("bv::refresh::table", "btable_main");
    }
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getTracking() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_get.php",
        data: {
          tracking_id: this.$route.params.id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.tracking = response.data.trackings[0];
      this.order_masters = response.data.orders;
      this.items.push(this.tracking);

      this.history_items = response.data.tracking_status_historys;
      this.loader.hide();

      this.getChangeRequests();
      this.getCsIssues();
    },

    async getChangeRequests() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_get.php",
        data: {
          search_criteria: {
            tracking_number: this.tracking.tracking_number,
          },
        },
      });
      this.cr_items = response.data.change_requests;
      this.loader.hide();
    },

    async executeCR(cr_item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_execute.php",
        data: {
          change_request_id: cr_item.id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      if (response.data.status == "success") {
        this.getTracking();
        this.getChangeRequests();
      } else {
        alert(response.data.error_msg);
      }
    },

    async cancelCR(cr_item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_cancel.php",
        data: {
          change_request_id: cr_item.id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.getChangeRequests();
    },

    showModal_reschedule_tracking(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_tracking.show();
    },

    hideModal_reschedule_tracking() {
      this.$refs.modal_reschedule_tracking.hide();
    },

    returnTracking(item) {
      this.updateTracking(item.order_id, "Returned to Warehouse", null, null);
    },

    rescheduleTracking() {
      this.updateTracking(
        this.updating_item.order_id,
        "Rescheduled",
        this.reschedule_type_selected,
        this.reschedule_date
      );
    },

    onManualReturnToWarehouse() {
      this.updateTracking(
        this.manual_return_order_id,
        "Returned to Warehouse",
        null,
        null
      );
    },

    async updateTracking(
      order_id,
      status,
      reschedule_delivery_type,
      reschedule_delivery_date
    ) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_update.php",
        data: {
          order_id: order_id,
          status: status,
          reschedule_type: reschedule_delivery_type,
          reschedule_delivery_date: reschedule_delivery_date,
          user_id: "0",
        },
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Tracking #${order_id} Update Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
      } else {
      }

      this.getTracking();
      this.$refs.modal_reschedule_tracking.hide();
    },

    showModal_cancelTracking(item) {
      this.updating_item = item;
      this.$refs.modal_cancelTracking.show();
    },

    hideModal_cancelTracking() {
      this.$refs.modal_cancelTracking.hide();
    },

    async deleteTrackingStatus() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_status_delete.php",
        data: {
          tracking_id: this.tracking.id,
          tracking_status_id: this.updating_item.id,
          status: this.updating_item.status,
          date: this.updating_item.date,
        },
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Tracking #${this.updating_item.tracking_number} Update Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
      }

      this.getTracking();
      this.hideModal_cancelTracking();
    },

    // showPod(item) {
    //   this.$eventHub.$emit("show_image_view", {
    //     image_url: item.pod_image,
    //     order_ids: item.order_ids,
    //     pod_at: item.pod_at
    //   });
    // },

    async showPod(item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_pod_get.php",
        data: {
          tracking_id: item.id,
          tracking_number: item.tracking_number,
        },
      });

      item.order_ids = response.data.order_ids;
      item.pod_at = response.data.pod_at;

      this.$eventHub.$emit("show_image_view", {
        image_url: item.pod_image,
        order_ids: item.order_ids,
        pod_at: item.pod_at,
      });
    },

    async getCsIssues() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: {
            tracking_id: this.tracking.id,
          },
        },
      });
      this.items = response.data.cs_issues;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    showModal_removePod(item) {
      this.updating_item = item;
      this.$refs.modal_removePod.show();
    },

    hideModal_removePod() {
      this.$refs.modal_removePod.hide();
    },

    async removePod() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "pod_remove.php",
        data: {
          tracking_id: this.tracking.id,
        },
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Tracking POD Removed.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
      }

      this.getTracking();
      this.hideModal_removePod();
    },

    async getOrderMasterProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_get.php",
        data: {
          order_number: this.tracking.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
        },
      });

      this.order_master_products = response.data.products;

      this.loader.hide();
    },
    async checkEpodExists() {
      try {
        const response = await this.$http({
          method: "GET",
          baseURL: `https://tracking.gols.com.hk/staging/api/`,
          url: "epod_get.php", // Replace with your actual API endpoint
          params: {
            action: "check",
            courier: this.tracking.courier_short_name,
            trackingNumber: this.tracking.tracking_number,
          },
        });

        if (response.data.exists) {
          this.epodExists = true; // Enable the button if ePOD exists
        }
      } catch (error) {
        console.error("Error checking ePOD:", error);
        this.epodExists = false;
      }
    },

    async downloadEpod() {
      try {
        const response = await this.$http({
          method: "GET",
          baseURL: `https://tracking.gols.com.hk/staging/api/`,
          url: "epod_get.php", // Replace with your actual API endpoint
          params: {
            action: "download",
            courier: this.tracking.courier_short_name,
            trackingNumber: this.tracking.tracking_number,
          },
          responseType: "blob", // Ensure the response is treated as a file
        });

        // Create a link and download the file
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.tracking.tracking_number}_ePOD.pdf`; // Filename for download
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Error downloading ePOD:", error);
      }
    },

    showModal_EditStatusDate(item) {
      this.editing_status_item = item;
      this.editStatusDate = item.updated_at;
      this.$refs.modal_editStatusDate.show();
    },

    hideModal_editStatusDate() {
      this.editing_status_item = null;
      this.editStatusDate = null;
      this.$refs.modal_editStatusDate.hide();
    },

    async saveEditStatusDate() {
      if (!this.editing_status_item || !this.editStatusDate) return;

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_status_date_update.php", // create this backend
        data: {
          tracking_status_id: this.editing_status_item.id,
          tracking_id: this.tracking.id,
          new_date: this.editStatusDate,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status === "success") {
        this.alert_success_message = "Status date updated successfully.";
        this.showAlert_success = true;
        setTimeout(() => (this.showAlert_success = false), 3000);
        this.getTracking();
      }

      this.hideModal_editStatusDate();
    }

  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dev_test {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/TrackingDetail.vue